import styled from 'styled-components';
export const Container = styled.div`
  position: fixed;
  display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
  top:0px;
  left: 0px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: ${({ zIndex }) => zIndex ? zIndex : 9999};
  cursor: default;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(5px);
`;
export const Content = styled.div`
  display: flex;
  border-radius: 6px;
  flex-direction: column;
  background-color: #f6f6f6;
  animation: scaleAnimation 400ms forwards;
  @keyframes scaleAnimation {
    0% {
      transform: scaleX(0) scaleY(0);
    }
    100% {
      transform: scaleX(1) scaleY(1);
    }
  }
`;
export const Header = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  padding: 0.5rem;
  justify-content:end;
  align-items: center;
  border-bottom: 2px solid #82878b33;  
`;
export const Title = styled.span`
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
  font-size:1.3rem;
  font-weight: 500;
  color: #000000;
`;
export const Icon = styled.span`
  display: flex;
  font-size: 2.5rem;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const Body = styled.div`
  display: flex;
  padding: 0.5rem;
  flex-direction: column;
  background-color: #FFFFFF;
  border-radius: 0 0 6px 6px;
`;